import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import { useAbyssViewerContext } from './AbyssViewerContext';
import { ViewerLayer } from './ViewerLayer';

export const useHybridRaycaster = (pickCanvasAreaPercent: number, isSphericalMode: boolean) => {
  const { hybridRaycaster, meshPickHelper, pickHelper } = useAbyssViewerContext();

  const gl = useThree((state) => state.gl);
  const setThreeState = useThree((state) => state.set);

  useEffect(() => {
    if (!hybridRaycaster) return;
    hybridRaycaster.layers.set(ViewerLayer.AutoPickable);
    setThreeState({ raycaster: hybridRaycaster });
  }, [hybridRaycaster, setThreeState]);

  useEffect(() => {
    if (!hybridRaycaster) return;
    if (isSphericalMode) {
      hybridRaycaster.layers.set(ViewerLayer.SphericalViewerLayer);
    } else {
      hybridRaycaster.layers.set(ViewerLayer.AutoPickable);
    }
  }, [hybridRaycaster, isSphericalMode]);

  useEffect(() => {
    if (!pickHelper) return;
    if (!hybridRaycaster) return;
    hybridRaycaster.setPickHelper(pickHelper);
  }, [hybridRaycaster, pickHelper]);

  useEffect(() => {
    if (!hybridRaycaster) return;
    if (!meshPickHelper) return;
    hybridRaycaster.setMeshPickHelper(meshPickHelper);
  }, [hybridRaycaster, meshPickHelper]);

  useEffect(() => {
    if (!hybridRaycaster) return;
    hybridRaycaster.setRenderer(gl);
  }, [hybridRaycaster, gl]);

  useEffect(() => {
    if (!hybridRaycaster) return;
    hybridRaycaster.setPickCanvasAreaPercent(pickCanvasAreaPercent);
  }, [hybridRaycaster, pickCanvasAreaPercent]);
};
